import React from 'react';
import type { ReactNode } from 'react';
interface ContainerProps {
  children: ReactNode;
  className?: string;
}
export function Container({
  children,
  className = ''
}: ContainerProps) {
  return <div className={`mx-auto w-full max-w-content px-5 sm:px-8 ${className}`} data-id="element-332" data-mp="1zfhf6o22qqbd">{children}</div>;
}